<template>
  <div class="form-container elevation-1">
    <v-form ref="form" @submit.prevent="resetClicked">
      <v-layout justify-end>
        <Logo class="ts-logo"/>
        <div class="ts-logo">
          ThinkSpatial
        </div>
      </v-layout>
      <h2 class="display-3">Reset Password</h2>
      <div class="form-region">
        <p>To reset your password, please enter your email address. An email with a 
          reset link will be mailed to you. If you do not receive a password reset email, check your email spam.</p>
        <v-text-field label="Email address" type="email" v-model="email" hint="Enter your email address." autocapitalize="false" :rules=[rules.required] />
      </div>
      <a class="blockify text-center" href="mailto:support@thinkspatial.com.au">Having trouble? Please contact ThinkSpatial Support directly.</a>
      <v-layout justify-end>
        <v-btn v-if="!sending" class="blockify" type="submit" dark variant="primary" color="#e7511e" >Reset</v-btn>
        <ball-scale-loader v-if="sending" color="#1976d2"/>
      </v-layout>
      <div class="red--text" v-html="error" />
    </v-form>
  </div>
</template>
<script>
import Logo from 'assets/svg/ts-logo-only.svg';
import { BallScaleLoader } from 'vue-loaders';
import CommonRules from 'src/common-rules.js';
import Authentication from '@/services/AuthenticationApi';
export default {
  components: {
    Logo,
    BallScaleLoader,
  },
  created: () => {
    document.title = 'ThinkSpatial | Forgotten Password';
  },
  data() {
    return {
      error: null,
      sending: false,
      email: null,
      rules: CommonRules
    }
  },
  methods: {
    async resetClicked() {
      try {
        if (this.$refs.form.validate()) {
          this.sending = true;
          const response = await Authentication.forgottenpassword({
            email: this.email
          })          
          this.sending = false;
          if(response.data.message.length > 0) {
            this.$swal({
              title: 'Success!',
              text: response.data.message,
              type: 'success'
            })
            .then(()=>{
              this.$router.push({
                name: 'default'
              })
            });
          }
        }
      } catch (err) {
        //this.error = err.response.data.error
        console.log(err)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import 'assets/landing.scss';
</style>
